const ufeApi = require('services/api/ufeApi');
const cookieUtils = require('utils/Cookies');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/GET+ROPIS+Specific+Product+Details

function getRopisSpecificProductDetails(profileId = 'current', productId, skuId = null) {
    const apiVersion = cookieUtils.isBXSProductEnabled() ? '/api/v3' : '/api2';

    let url = `${apiVersion}/users/profiles/${profileId}/ropisproduct/${productId}`;
    const queryParams = [];

    if (skuId !== null) {
        queryParams.push(`?preferedSku=${skuId}`);
    }

    url = url + queryParams.join('&');

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getRopisSpecificProductDetails;
